import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "my-auto",
  src: "/icons/ic_close.svg"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex h-full w-full",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickHandler($event)))
  }, _hoisted_2))
}